<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="40" viewBox="0 0 1024 45">
  <defs>
    <linearGradient id="linear-gradient" y1="-0.159" x2="0.5" y2="0.667" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
  </defs>
  <g id="xiaobiao5" transform="translate(0 -1)">
    <circle id="椭圆_825" data-name="椭圆 825" cx="22.5" cy="22.5" r="22.5" transform="translate(0 1)" fill="url(#linear-gradient)"/>
    <text id="项目执行人性别分布" transform="translate(16 36)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
